<template>
  <div class="row">
    <div class="col-12">
      <h4 class="my-galleries">
        {{$t("myOrders.title")}}
      </h4>
    </div>

    <div class="col-12">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">{{$t("myOrders.table.status")}}</th>
            <th scope="col">{{$t("myOrders.table.number")}}</th>
            <th scope="col">{{$t("myOrders.table.date")}}</th>
            <th scope="col">{{$t("myOrders.table.items")}}</th>
            <th scope="col">{{$t("myOrders.table.total")}}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" v-bind:key="order.id">
            <th class="text-start">{{ $t(`order.statuses.${order.status}`) }}</th>
            <td class="text-center">{{ order.order_number }}</td>
            <td class="text-start">{{ order.created_at | toLongDateTime }}</td>
            <td class="text-center">{{ order.total_items }}</td>
            <td class="text-end">{{ order.total | toCurrencyDecimals }}</td>
            <td>
              <div v-if="hasLink(order)">
                <a :href="order.link" target="_blank">
                  {{ $t('order.download') }}
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import User from "../../models/User";
import { UserOrderApi } from "../../api/UserOrderApi";

export default {
  name: "MyOrders",
  props:   {
    userId: {
      type: Number,
    },
  },
  data() {
    return{
      user: new User(),
      orders: [],
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.orders = await UserOrderApi.fetch(this.userId);
    },
    hasLink(order) {
      return (order.link.length > 0);
    }
  }
}
</script>

<style lang="scss">
  .my-galleries {
    text-align: left;
  }
</style>
